/* eslint-disable */
export const getFiveToFollowData = () => {
    return {
        '85922583': [
            // San Francisco
            {
                organizer_articles: [
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/1015-folsom-20011836089?aff=ebriterallysf',
                        profile_image:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F86813339%2F313881584809%2F1%2Foriginal.20200108-193259?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=175%2C0%2C849%2C849&s=768cc344fc4a0fa6d6bc2339242fcac5',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/11/07154929/DJ-main-stage-1015-1348x900.jpg',
                        name: '1015 Folsom',
                        id: '20011836089',
                        description:
                            'up-and-coming DJs, five spacious rooms, and parties galore.',
                        sub_description:
                            "Gigs here focus around electronic, dance, and instrumental hip hop. San Francisco's largest club has won dozens of awards for the best venue and nightclub in the US.",
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/great-american-music-hall-8103321951?aff=ebriterallysf',
                        profile_image:
                            'https://cdn.evbuc.com/images/52479043/140666818972/2/logo.png',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/11/07155018/GAMH_emptyroom-1340x900.png',
                        name: 'Great American Music Hall',
                        id: '8103321951',
                        description:
                            'the best rock shows to come to town, and the best acoustics.',
                        sub_description:
                            "The Great American Music Hall — San Francisco's oldest and grandest nightclub — has a rich musical history with bands like Arcade Fire, St. Vincent, and Grateful Dead among many others.",
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/noise-pop-presents-14685663046?aff=ebriterallysf',
                        profile_image:
                            'https://cdn.evbuc.com/images/44731497/220866562708/2/logo.png',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/11/07174556/NP_DreamWife_CafeDuNord_IanYoung.jpg',
                        name: 'Noise Pop Presents',
                        id: '14685663046',
                        description:
                            'a large swath quality indie artists and Bay Area venues.',
                        sub_description:
                            'Broaden your musical horizons with early exposure to indie music and emerging artists performing at a variety of venues around the city like Starline Social Club and Cafe du Nord.',
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/the-new-parish-17588861165?aff=ebriterallysf',
                        profile_image:
                            'https://cdn.evbuc.com/images/49669485/264219902540/1/logo.jpg',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/11/07155053/NewParish_GoodMusicOakland-1350x900.jpg',
                        name: 'The New Parish',
                        id: '17588861165',
                        description:
                            'reggae, hip-hop, R&B, dance parties, and more.',
                        sub_description:
                            "Immerse yourself in the culture and community of uptown Oakland on The New Parish's huge dance floor, outdoor patio, or cozy balcony.",
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/the-uc-theatre-17398923846',
                        profile_image:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F46814072%2F258870394286%2F1%2Foriginal.jpg?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C2400%2C2400&s=b2b680086b6bf5eb4e504acd0930bb6c',
                        article_image:
                            'https://live.staticflickr.com/65535/49014922648_aa5308eb81_h.jpg',
                        name: 'The UC Theatre Taube Family Music Hall',
                        id: '17398923846',
                        description:
                            'artists from all over the world and a range of genres.',
                        sub_description:
                            "With acts from all genres, this midsize concert venue's calendar is guaranteed to have an artist you know and love! This downtown Berkeley spot is a must-follow for Bay Area concert-goers.",
                        upcoming: null,
                        followed_by_you: false,
                    },
                ],
                name:
                    '5 to Follow: For Great Shows in the San Francisco Bay Area',
                description:
                    'Follow these Eventbrite music creators to discover the local independent music scene, stay in the loop on the hottest shows, and expand your list of go-to music venues.',
                article_id: '206373',
                key: 'five_to_follow_in_music',
            },
            {
                organizer_articles: [
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/cuesa-center-for-urban-education-about-sustainable-agriculture-427849125?aff=ebriterally_article_sf',
                        profile_image:
                            'https://cdn.evbuc.com/images/21936814/2228066046/2/logo.png',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/09/03093004/CUESA_Summer_Jam_.jpg',
                        name:
                            'CUESA Center for Urban Education About Sustainable Agriculture',
                        id: '427849125',
                        description:
                            "seasonal dinner and cocktail parties chock full of farmers' market fresh ingredients, plus star chefs and bartenders.",
                        sub_description:
                            'CUESA is an incredible nonprofit focused on urban education and sustainable agriculture and hosts a wide array of events including seminars on agriculture and food justice, seasonal suppers and cocktail parties, and farm tours throughout the Bay Area.',
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/spark-social-sf-11045011638?aff=ebriterally_article_sf',
                        profile_image:
                            'https://cdn.evbuc.com/images/37363575/83236826533/2/logo.jpg',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/09/03102854/39296922_2082024428780885_1442803033690865664_o.jpg',
                        name: 'SPARK Social SF',
                        id: '11045011638',
                        description:
                            "mimosa yoga and bootcamp brunches, Avocadocon, and other themed food events. Combine your food love with a workout at one of Spark Social SF's combo events that will keep you energized, fed, and maybe a little tipsy.",
                        sub_description:
                            'SPARK Social SF hosts food and booze filled events for major sports games and holidays, giving you a ready made spot to gather your crew to celebrate with food truck bites and plenty of drinks.',
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/the-civic-kitchen-cooking-school-26467839971',
                        profile_image:
                            'https://cdn.evbuc.com/images/70333793/331919579051/1/logo.jpg',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/09/19194000/https___cdn.evbuc_.com_images_70329287_331919579051_1_original.jpeg',
                        name: 'The Civic Kitchen Cooking School',
                        id: '26467839971',
                        description:
                            'globally inspired, hand on cooking classes taught in a welcoming space in the Mission District.',
                        sub_description:
                            "Whether you're a home chef looking to step up your thriving dinner party game or a newbie just trying to figure out how to make something edible, The Civic Kitchen's comfortable, friendly space is the perfect place to learn to cook any type of cuisine.",
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/kitchentown-7940420568?aff=ebriterally_article_sf',
                        profile_image:
                            'https://cdn.evbuc.com/images/54397315/135343065750/2/logo.png',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/09/03104952/KITCHENTOWN.jpg',
                        name: 'KITCHENTOWN',
                        id: '7940420568',
                        description:
                            'classes to turn your friend group famous cake creations into a viable business.',
                        sub_description:
                            'Kitchentown offers classes for burgeoning food makers to help you make your food empire daydreams come true. Find out how to get a food startup loan, or how to take your food business online.',
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/soma-streat-food-park-7721350739?aff=ebriterally_article_sf',
                        profile_image:
                            'https://cdn.evbuc.com/images/37273689/83236826533/2/logo.jpg',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/09/03105055/SoMa_StrEat_Food_Park_.jpg',
                        name: 'SoMa StrEat Food Park',
                        id: '7721350739',
                        description:
                            "theme days! Whether you're a doughnut fiend or an ube fanatic, SoMa has a theme day for you.",
                        sub_description:
                            "SoMa StrEat Food Park knows how to party. Step one: They pick out a drink or an ingredient that you're totally obsessed with. Step 2: They fill the park with food trucks slinging awesome spins on that craveworthy star. Step 3: Repeat after me: bottomless drink specials, DJs, and general delicious debauchery.",
                        upcoming: null,
                        followed_by_you: false,
                    },
                ],
                name: '5 to Follow: For the San Francisco Food Lover',
                description:
                    "San Francisco is a foodie paradise. But in a city packed with so many delicious markets, classes, and festivals, it's easy to miss out on your dream food adventure. Want to stay in the loop on all the hottest upcoming foodie events in San Francisco? We've got the solution.",
                article_id: '182153',
                key: 'five_to_follow_in_food_and_drink',
            },
        ],
        '85977539': [
            // New York
            {
                organizer_articles: [
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/avant-gardner-llc-19690491312',
                        profile_image:
                            'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F50822942%2F234108706359%2F2%2Foriginal.png?w=225&auto=compress&s=c67137fd9e9a3c37f29d5b80a99f6c51',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/11/08094335/Avant-Gardner.jpg',
                        name: 'Avant Gardner',
                        id: '17344195410',
                        description:
                            'DJ sets from the world’s frontrunning producers.',
                        sub_description:
                            'Just on the border of Williamsburg, this multi-stage event complex features DJs and artists from around the globe that fully immerse you in the tracks.',
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/popgun-presents-8182660460',
                        profile_image:
                            'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F34750668%2F143529889148%2F2%2Foriginal.jpg?w=225&auto=compress&s=b5ed6fe1fb0f8cb9079c46e5b0bdc86e',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/10/08095244/PopGun_Elsewhere.jpg',
                        name: 'PopGun Presents',
                        id: '8182660460',
                        description:
                            'indie rock, electro pop, and everything in between.',
                        sub_description:
                            'PopGun Presents’ venue, Elsewhere, hosts emerging artists on four different stages so there’s never a shortage of expertly curated musical variety.',
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/le-poisson-rouge-12931343171',
                        profile_image:
                            'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F29605521%2F202876063621%2F2%2Foriginal.jpg?w=225&auto=compress&s=5059b3c5b58b9a75e0c66c23910c21fa',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/11/08094407/LPR-front-entrance-Photo-Credit-Sachyn-Mital.jpg',
                        name: '(le) poisson rouge',
                        id: '12931343171',
                        description:
                            'indie pop, rock, EDM, folk, reggae, and jazz, and more.',
                        sub_description:
                            'Local legends and international up and comers from every genre share the stage in this immersive event space, a NYC music scene staple.',
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/knockdown-center-17276085958',
                        profile_image:
                            'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F47107694%2F254917237547%2F1%2Foriginal.jpg?w=180&auto=compress&rect=0%2C0%2C180%2C180&s=60e8b3f82acaccdc65b53f2945f90e3d',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/10/08095322/Knockdown-Center.jpg',
                        name: 'Knockdown Center',
                        id: '17276085958',
                        description:
                            'music, community seminars, free art shows, and theme nights.',
                        sub_description:
                            'This versatile music, art, and performance space is the go-to spot in Queens for those looking for something different than your standard night out.',
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/adhoc-presents-new-york-17573655465',
                        profile_image:
                            'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F52167022%2F184457607660%2F1%2Foriginal.jpg?w=512&auto=compress&rect=0%2C0%2C1000%2C1000&s=26cb2dfb7b8f20e7c638942f272d75b6',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/10/08115129/Princess-Nokia-Villain-by-Gretchen-Robinette-1_preview-copy.jpg',
                        name: 'AdHoc Presents New York',
                        id: '17573655465',
                        description: 'indie rock and pop.',
                        sub_description:
                            'This Brooklyn based concert promoter doubles as a music publication, filling some of the city’s most intimate venues with raw talent for concert goers who just want to hear good music.',
                        upcoming: null,
                        followed_by_you: false,
                    },
                ],
                name: '5 to Follow: For Music Lovers in NYC',
                description:
                    'The city that never sleeps needs a soundtrack, and these five music forward venues offer unique shows that won\u2019t break the bank. Follow them and you\u2019ll be the first to know about these under the radar gigs.',
                article_id: '206821',
                key: 'five_to_follow_in_music',
            },
            {
                organizer_articles: [
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/cocusocial-cooking-classes-13781027617?aff=ebriterallynyc',
                        profile_image:
                            'https://cdn.evbuc.com/images/33072447/79175508931/2/logo.png',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/09/01192540/Cocusocial_.jpg',
                        name: 'CocuSocial Cooking Classes',
                        id: '13781027617',
                        description:
                            'classes on how to make Spanish paella, Japanese ramen, French macarons, and a diverse selection of other cooking classes for less than $50 a person.',
                        sub_description:
                            "With large scale events at restaurants and hotels big enough for you and your whole group of friends, you can learn how to make cuisine from all over the world. Whether you're passionate about cooking or just want a fun night out with your crew, Cocusocial will hook you up with a memorable and delicious experience.",
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/enlightenment-wines-meadery-11376607675',
                        profile_image:
                            'https://cdn.evbuc.com/images/24163073/142088571055/3/logo.jpg',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/09/26104242/mead.jpg',
                        name: 'Enlightenment Wines Meadery',
                        id: '11376607675',
                        description:
                            'tours of the meadery, plus classes on things like herbal tonics, miso making, and mushroom cultivation.',
                        sub_description:
                            'Learn about mead (which is a honey based wine) among other funky food and drinks at this Brooklyn and Hudson Valley based operation.',
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/murrays-cheese-8172404165',
                        profile_image:
                            'https://cdn.evbuc.com/images/13608834/141392852881/2/logo.png',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/10/14132142/murrays-cheese-classes.jpg',
                        name: "Murray's Cheese",
                        id: '8172404165',
                        description:
                            'wine pairings, grilled cheese primers, and make your own burrata classes',
                        sub_description:
                            "If you're passionate about cheese, Murray's is your dream destination. Learn the fundamentals in a Cheese 101 course, or snack and relax at a cheese and meditation workshop.",
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/hungry-pop-19939184060',
                        profile_image:
                            'https://cdn.evbuc.com/images/64528468/255867506188/2/logo.png',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/09/23175535/080919_Yasmin-Alishav_Make-Pizza-Drink-Wine_Keste_NY-NY-USA_054.jpg',
                        name: 'Hungry Pop',
                        id: '19939184060',
                        description:
                            'fun group classes that focus on pizza and pasta making.',
                        sub_description:
                            "Get a lesson from expert chefs on how to make Italian specialties like mozzarella, pizza, and pasta. And if that didn't sound fun enough, the folks at Hungry Pop make sure you're not thirsty by offering bottomless wine.",
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/michel-et-augustin-12730150613',
                        profile_image:
                            'https://cdn.evbuc.com/images/51521854/199607744421/2/logo.jpg',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/09/23175224/IMG_0501.jpg',
                        name: 'Michel et Augustin',
                        id: '12730150613',
                        description:
                            'freshly baked fresh treats and free hands on monthly baking classes.',
                        sub_description:
                            'With a focus on sharing their passion with consumers, Michel et Augustin offers a free open house the first Thursday of every month at both of their headquarters, where they host a hands on baking lesson.',
                        upcoming: null,
                        followed_by_you: false,
                    },
                ],
                name: '5 to Follow: Organizers to Up Your Food Game in NYC',
                description:
                    'New York may a city filled with endless dining options, but let\u2019s be honest: the city\u2019s food scene goes way beyond restaurants. There are endless options for cooking classes, tastings, and reveling. However you like to indulge, we picked five of our favorite event organizers that will make your life a little more delicious.',
                article_id: '182105',
                key: 'five_to_follow_in_food_and_drink',
            },
        ],
        '85940195': [
            // Chicago
            {
                organizer_articles: [
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/thalia-hall-14941061407',
                        profile_image: '',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/12/18063449/ThaliaHall.jpg',
                        name: 'Thalia Hall',
                        id: '14941061407',
                        description:
                            'its historic theater with a calendar of great musical acts.',
                        sub_description:
                            'Since 1892, this landmark caters to all types of music lovers with a variety of artists, from industry mainstays to trendsetting up-and-comers.',
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/space-15033692316',
                        profile_image:
                            'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F35007889%2F225372329830%2F2%2Foriginal.jpg?w=225&auto=compress&s=26b7488b404ed5a36a705b5826554a96',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/12/18063659/SPACE_dance_floor.jpg',
                        name: 'SPACE',
                        id: '15033692316',
                        description:
                            'americana, country, folk, jazz, and then some.',
                        sub_description:
                            'Located in Evanston, a quick drive north of Chicago, SPACE is one of the area’s most prolific and intimate venues. Catch both local and national touring acts almost every night of the week.',
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/the-promontory-15186243753',
                        profile_image:
                            'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F40484199%2F224195095473%2F2%2Foriginal.jpeg?w=225&auto=compress&s=5fc921d34f7252e3329f6589f375b9d2',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/12/18063812/ThePromontory.jpg',
                        name: 'The Promontory',
                        id: '15186243753',
                        description:
                            'the party never stops at this restaurant/performance space.',
                        sub_description:
                            'Expect Afro Caribbean, R&B, and reggae dance parties, community events, and jazz and hip hop frontrunners at this venue, located just a short walk from the neighborhood’s beloved Promontory Point.',
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/the-empty-bottle-14942261751',
                        profile_image:
                            'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F35066368%2F224195700680%2F2%2Foriginal.jpg?w=225&auto=compress&s=8146b238bc634cfe508d1e02efd12374',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/12/18064104/TheEmptyBottle.jpg',
                        name: 'The Empty Bottle',
                        id: '14942261751',
                        description:
                            'underground rock, pop, and electronic independents.',
                        sub_description:
                            'A staple of the Ukrainian Village since the early ‘90s, this hole-in-the wall bar has that classic indie venue vibe with a pool table, exposed brick, and custom graffitied bathrooms.',
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/the-riviera-25797504239',
                        profile_image:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F68814007%2F313967227138%2F1%2Foriginal.20190815-205408?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C600%2C600&s=17531e0c2792b6e7c155766bc7e2a2fb',
                        article_image:
                            'https://cdn.evbstatic.com/s3-build/perm_001/1b0c60/django/images/homefeed/articles/TheRiviera-chi.jpg',
                        name: 'The Riviera',
                        id: '25797504239',
                        description:
                            'hosting A-listers before they graduate to the arenas.',
                        sub_description:
                            'The Riviera is a staple in Chicago’s historic Uptown theater district, showcasing the best national and international touring acts. Think Twin Peaks, The Roots, King Princess, Jaden and Willow Smith... you get the picture.',
                        upcoming: null,
                        followed_by_you: false,
                    },
                ],
                name:
                    '5 to Follow: To Stay Tuned In to the Chicago Music Scene',
                description:
                    'Chicago\u2019s music scene is sweeping in more musical talent than ever, so be the first to know when the next divergent sounds will reach the Chicago stages by following these bustling performance venues.',
                article_id: '224091',
                key: 'five_to_follow_in_music',
            },
        ],
        '85931779': [
            // Washington DC
            {
                organizer_articles: [
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/songbyrd-music-house-17992305645',
                        profile_image:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F52319892%2F244028970494%2F1%2Foriginal.jpg?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C600%2C600&s=604dc418333b2dac805c30045db9b3b3',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/12/04161315/19023420_1366745873440671_8565030172771810107_o.jpg',
                        name: 'Songbyrd Music House',
                        id: '17992305645',
                        description:
                            'music and comedy with retro vibes and a curated vinyl shop.',
                        sub_description:
                            'Located in the Adams Morgan neighborhood, the three-in-one record cafe, restaurant and bar, and music venue was named the Best Place for Dinner and Live Music by the Washington City Paper in 2017.',
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url: 'https://www.eventbrite.com/o/26368614219',
                        profile_image: '',
                        article_image:
                            'https://cdn.evbstatic.com/s3-build/perm_001/03dff3/django/images/homefeed/articles/GlowAtEchostage-dc.jpg',
                        name: 'Glow at Echostage',
                        id: '26368614219',
                        description: 'UNST UNST UNST UNST UNST!',
                        sub_description:
                            'This is DC’s newest and largest nightlife concert venue, so expect to see world-class DJs like David Guetta, Calvin Harris, Avicii, Armin van Buuren, Hardwell and Tiesto.',
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/the-hamilton-live-26114521937',
                        profile_image:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F57926036%2F289993732209%2F1%2Foriginal.20190305-214420?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C951%2C13097%2C13097&s=c58ba80e57e98f7f0800b86b2dbe0ea4',
                        article_image:
                            'https://cdn.evbstatic.com/s3-build/perm_001/330261/django/images/homefeed/articles/TheHamiltonLive-dc.jpg',
                        name: 'The Hamilton Live',
                        id: '26114521937',
                        description:
                            'everything from string and folk bands to reggae and pop stars',
                        sub_description:
                            "Located just two blocks from the White House, The Hamilton is the District's newest destination for envelope-pushing, visionary music and talent that defies convention, much like Hamilton himself.",
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/dc9-nightclub-18157230091',
                        profile_image:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F54574481%2F166960203242%2F1%2Foriginal.20190103-191158?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C1688%2C1688&s=b72190e28cf6c242322d50aa5553166a',
                        article_image:
                            'https://cdn.evbstatic.com/s3-build/perm_001/4819b9/django/images/homefeed/articles/DC9Nightclub-dc.jpg',
                        name: 'DC9 Nightclub',
                        id: '18157230091',
                        description:
                            'indie rock, DJ sets, karaoke and dance parties.',
                        sub_description:
                            "This indie rock haven was founded in 2004 and is a regular stop for bands like Peach Pit and Katastro. The intimate room also throws themed karaoke and dance parties – everyone's guilty pleasure.",
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/milkboy-arthouse-21665812442',
                        profile_image:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F65772443%2F311491485414%2F1%2Foriginal.20190717-213425?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C2100%2C2100&s=6cfefa74814a8f308dc21ebd22bee485',
                        article_image:
                            'https://cdn.evbstatic.com/s3-build/perm_001/a56397/django/images/homefeed/articles/MilkBoyArtHouse-dc.jpg',
                        name: 'MilkBoy ArtHouse',
                        id: '21665812442',
                        description:
                            'pop, indie rock, jazz, world music, film and then some.',
                        sub_description:
                            'The community-inspired MilkBoy ArtHouse is a performance venue, restaurant, and bar that hosts a range of emerging art and pop culture events.',
                        upcoming: null,
                        followed_by_you: false,
                    },
                ],
                name: '5 to Follow: For Music Lovers in DC',
                description:
                    'Without a doubt, Washington, DC is a vital hotspot for all your favorite artists to hit when they tour the East Coast. From Echostage to Songbyrd Music Hall, we\u2019ve chosen 5 of DC\u2019s iconic music venues and promoters to follow so you\u2019ll never miss out on a live music event that thrills you.',
                article_id: '217899',
                key: 'five_to_follow_in_music',
            },
        ],
        '85923517': [
            // Los Angeles
            {
                organizer_articles: [
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/bender-4673296677?aff=ebriterally_article_la',
                        profile_image:
                            'https://cdn.evbuc.com/images/19449381/1204797961/2/logo.jpg',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/08/27211504/BENDER.jpg',
                        name: 'Bender Flow',
                        id: '4673296677',
                        description:
                            'scenic yoga classes on the rooftop of ROW DTLA and at OUE Skyspace',
                        sub_description:
                            "With an emphasis on gratitude, openness, and acceptance, yoga is all about gaining perspective and if you ask us, there's no better perspective than from a rooftop yoga class.",
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/downward-grog-15549544178?aff=ebriterally_article_la',
                        profile_image:
                            'https://cdn.evbuc.com/images/38599275/44167422800/2/logo.png',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/08/27211624/Downward_Grog.jpg',
                        name: 'Downward Grog',
                        id: '15549544178',
                        description:
                            'yoga classes held at breweries across LA.',
                        sub_description:
                            'Have you ever finished a workout and wished a cold beer was waiting for you as a reward? We feel you and so does Downward Grog, the LA based organizer proving that yoga people and beer people can be one and the same.',
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/kundalini-yoga-by-the-sea-15181572280?aff=ebriterally_article_la',
                        profile_image: '',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/08/27211751/Kundalini_Yoga_By_The_Sea.jpg',
                        name: 'Kundalini Yoga by the Sea',
                        id: '15181572280',
                        description:
                            'kundalini yoga classes as well as reiki training, mindfulness workshops, sound baths, and other mind and body focused events.',
                        sub_description:
                            'Reach your nirvana Kundalini, a physical and spiritual combination yoga practice shaped around the Hindu concept of primal energy',
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/laughing-frog-yoga-11086118385?aff=ebriterally_article_la',
                        profile_image:
                            'https://cdn.evbuc.com/images/39999282/182547473668/2/logo.jpg',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/08/27211933/Laughing_Frog_Yoga.jpg',
                        name: 'Laughing Frog Yoga',
                        id: '11086118385',
                        description:
                            'two words: Goat yoga. Try out one of the most popular yoga trends to hit social media.',
                        sub_description:
                            "With almost every single class filling up in a matter of days, Laughing Frog's yoga classes are some of the most in demand and hardest to get into in LA.",
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/liberate-hollywood-15402414429?aff=ebriterally_article_la',
                        profile_image:
                            'https://cdn.evbuc.com/images/40435566/230583304087/2/logo.jpg',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/08/27212033/Liberate_Hollywood.jpg',
                        name: 'Liberate Hollywood',
                        id: '15402414429',
                        description:
                            'Rockstar Magical Flow Yoga, a playlist driven series that takes place in what was formerly the world renowned Hollywood Sound Recorders Studio.',
                        sub_description:
                            "Though Liberate Hollywood offers some of the best and most Zen yoga classes in LA, don't confuse this healing center with your average exercise studio.",
                        upcoming: null,
                        followed_by_you: false,
                    },
                ],
                name: '5 to Follow: To Get Your Ohm On in Los Angeles',
                description:
                    "You follow your favorite artists, venues, and meme accounts on Instagram. Now, you can keep up with your favorite event creators on Eventbrite. Simply tap the follow button to make sure you never miss tickets from your favorite creators. You'll get an email from Eventbrite whenever a new event goes on sale so you'll never [&hellip;]",
                article_id: '179719',
                key: 'five_to_follow_in_health_and_wellness',
            },
            {
                organizer_articles: [
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/exchange-la-17588567121',
                        profile_image:
                            'https://cdn.evbuc.com/images/47795128/265681973896/1/logo.jpg',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/11/08111414/Exchange_LA.jpg',
                        name: 'Exchange LA',
                        id: '17588567121',
                        description:
                            'dance parties headlined by DJs and pop artists.',
                        sub_description:
                            'This four-level nightclub located in the former Los Angeles Stock Exchange building is as close to Las Vegas as LA gets including when it comes to attracting electronic headliners.',
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/lodge-room-20048664093',
                        profile_image: '',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/11/08111717/The_Lodge_Room.jpg',
                        name: 'Lodge Room',
                        id: '15465136431',
                        description:
                            'a packed calendar of shows by indie artists.',
                        sub_description:
                            'Originally built as the Highland Park Masonic Temple, this venue is now one of the best destinations on the East Side for fans of indie and alternative music.',
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/the-echo-25636758843',
                        profile_image:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F67431379%2F196102453953%2F1%2Foriginal.20190803-001447?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C1500%2C1500&s=e14c5d3e3a99877b861b87a7c204b2e7',
                        article_image:
                            'https://www.spacelandpresents.com/files/2019/11/menzingers-regent-zane-roessell-11-10-2019-2494-800x533.jpg',
                        name: 'The Echo',
                        id: '25636758843',
                        description:
                            'the hottest indie bands from around the world.',
                        sub_description:
                            "The Echo (and its sister-venue, Echoplex) is a staple of L.A.'s music scene, providing an intimate experience with industry frontrunners like Cat Power and Franc Moody.",
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/the-regent-theater-25636825305',
                        profile_image:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F67429185%2F196102453953%2F1%2Foriginal.20190802-233650?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C1500%2C1500&s=73e3d8f74cdc6f52cf0c02f2a51503e1',
                        article_image:
                            'https://www.spacelandpresents.com/files/2019/11/menzingers-regent-zane-roessell-11-10-2019-2494-800x533.jpg',
                        name: 'The Regent Theater',
                        id: '25636825305',
                        description:
                            'concerts, dances, theater, movies, festivals...YOU NAME IT! ',
                        sub_description:
                            "Opened in 1914, The Regent is a historic movie theater transformed into Downtown L.A.'s entertainment hub. From artist interviews to live podcasts and sold-out shows, this place has it all.",
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/moroccan-lounge-19952006191',
                        profile_image:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F62365084%2F299755853036%2F1%2Foriginal.20190515-233607?w=449&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C9%2C449%2C449&s=7f3086f295f46fc33e1437036854702f',
                        article_image:
                            'https://www.themoroccan.com/files/2017/08/DSC00805.jpg',
                        name: 'Moroccan Lounge',
                        id: '19952006191',
                        description:
                            'a steady rotation of up-and-comers and big-name drop-ins',
                        sub_description:
                            'The Moroccan features emerging artists and established stars alike. For instance, the intimate room will see newcomers like Sir Woman and Kyle Lux alongside names like Tall Heights and Circa Waves.',
                        upcoming: null,
                        followed_by_you: false,
                    },
                ],
                name:
                    '5 to Follow: To Stay Tuned Into the Los Angeles Music Scene',
                description:
                    'As the hub of the entertainment industry, Los Angeles is one of the best places in the world to see live music. Follow these independent platforms, pop up concert organizers, and live music venues for first dibs on tickets to the best shows in LA. You follow your favorite artists, venues, and meme accounts on Instagram. [&hellip;]',
                article_id: '206927',
                key: 'five_to_follow_in_music',
            },
        ],
        '101750367': [
            // London
            {
                organizer_articles: [
                    {
                        profile_url:
                            'https://www.eventbrite.co.uk/o/mads-mydivalution-8252791968',
                        profile_image:
                            'https://cdn.evbuc.com/images/20052254/145843947959/2/logo.png',
                        article_image:
                            'https://blogmedia.evbstatic.com/wp-content/uploads/rally-legacy/2018/09/21055802/twenty20_6613d3c0-75e5-440c-a56d-ecae872384d6-1350x900.jpg',
                        name: 'Mads MyDivalution',
                        id: '8252791968',
                        description: '',
                        sub_description: '',
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.co.uk/o/right-path-fitness-17303057446',
                        profile_image: '',
                        article_image: '',
                        name: 'Right Path Fitness',
                        id: '17303057446',
                        description: '',
                        sub_description: '',
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.co.uk/o/swedish-fit-10398084628',
                        profile_image:
                            'https://cdn.evbuc.com/images/23269111/170333334023/2/logo.gif',
                        article_image: '',
                        name: 'Swedish Fit',
                        id: '10398084628',
                        description: '',
                        sub_description: '',
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.co.uk/o/new-motion-fitness-17578640115',
                        profile_image: '',
                        article_image: '',
                        name: 'New Motion Fitness',
                        id: '17578640115',
                        description: '',
                        sub_description: '',
                        upcoming: null,
                        followed_by_you: false,
                    },
                    {
                        profile_url:
                            'https://www.eventbrite.com/o/maihem-17620308768',
                        profile_image: '',
                        article_image: '',
                        name: 'Maihem',
                        id: '17620308768',
                        description: '',
                        sub_description: '',
                        upcoming: null,
                        followed_by_you: false,
                    },
                ],
                name: '5 to Follow: For Autumn Workouts with a Difference',
                description:
                    "The summer of 2018 will live long in the memory but, as Future Islands once sung, seasons change, and with it comes a chance to start afresh. If you're looking to renew or ramp up your workout efforts this autumn, then you're in luck as Adam Bloodworth profiles five of the best event creators [&hellip;]",
                artcle_id: '188407',
                key: 'five_to_follow_in_health_and_wellness',
            },
        ],
    };
};
/* eslint-enable */
